// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3LGbm","rightAdornment":"Header_rightAdornment__3ONHr"};